import { StageConfig } from '../types';

export const STAGES: StageConfig[] = [
  { id: 1, nameKey: 'stage.1', theme: 'laboratory', description: 'Research Laboratory' },
  { id: 2, nameKey: 'stage.2', theme: 'city', description: 'City Streets' },
  { id: 3, nameKey: 'stage.3', theme: 'hospital', description: 'Abandoned Hospital' },
  { id: 4, nameKey: 'stage.4', theme: 'sewer', description: 'Underground Sewer' },
  { id: 5, nameKey: 'stage.5', theme: 'military', description: 'Military Base' },
  { id: 6, nameKey: 'stage.6', theme: 'subway', description: 'Subway Station' },
  { id: 7, nameKey: 'stage.7', theme: 'factory', description: 'Industrial Factory' },
  { id: 8, nameKey: 'stage.8', theme: 'forest', description: 'Dark Forest' },
  { id: 9, nameKey: 'stage.9', theme: 'airport', description: 'Airport Terminal' },
  { id: 10, nameKey: 'stage.10', theme: 'finalLab', description: 'Final Research Facility' },
];
